module.exports = __webpack_public_path__ + "img/expired.d4db8a50.png";